import { JoinMembership } from '../../auth/components/start-membership/JoinMembership';

export default function JoinMembershipScreen() {
    return <JoinMembership />;
}
